
























































































































































































































































import { EmailAttachmentApi } from '@/api/email-attachment';
import { PartnerPracticeApi } from '@/api/partner-practice';
import { BadRequest } from '@/api/responses/bad-request';
import { UserApi } from '@/api/user';
import addressWithLookup from '@/components/address-with-lookup.vue';
import loading from '@/components/loading.vue';
import partnerPracticeAddressList from '@/components/settings/partner-practices/partner-practice-address-list.vue';
import partnerPracticeDetails from '@/components/settings/partner-practices/partner-practice-details.vue';
import partnerPracticeEmailList from '@/components/settings/partner-practices/partner-practice-email-list.vue';
import partnerPracticeEmail from '@/components/settings/partner-practices/partner-practice-email.vue';
import partnerPracticeOriginalSources from '@/components/settings/partner-practices/partner-practice-original-sources.vue';
import userDetails from '@/components/settings/users/user-details.vue';
import userRoles from '@/components/settings/users/user-roles.vue';
import userTargets from '@/components/settings/users/user-targets.vue';
import usersTable from '@/components/settings/users/users-table.vue';
import { PartnerPractice } from '@/shared/partner-practice';
import { createPartnerPracticeAddress, PartnerPracticeAddress } from '@/shared/partner-practice-address';
import { createPartnerPracticeEmailAttachment, PartnerPracticeEmailAttachment } from '@/shared/partner-practice-email-attachment';
import { createUser, User } from '@/shared/user';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

const userModule = namespace('user');
const usersModule = namespace('users');

const emailAttachmentApi = new EmailAttachmentApi();
const partnerPracticeApi = new PartnerPracticeApi();
const userApi = new UserApi();

@Component({
    components: {
        addressWithLookup,
        loading,
        partnerPracticeAddressList,
        partnerPracticeDetails,
        partnerPracticeEmailList,
        partnerPracticeEmail,
        partnerPracticeOriginalSources,
        userDetails,
        userRoles,
        userTargets,
        usersTable,
    },
})
export default class AddPartnerPracticeDialog extends Vue {
    @userModule.Getter('isAdministrator') private isAdministrator!: boolean;

    @usersModule.Getter('partnerPracticeUsers') private partnerPracticeUsers!: (partnerPracticeId: string) => Array<User>;

    @Prop({ required: true }) private visible!: boolean;
    @Prop({ required: true }) private partnerPractice!: PartnerPractice;

    private isVisible: boolean = this.visible;
    private isLoading: boolean = true;
    private isSaving: boolean = false;
    private currentTab: number = 0;
    private showDetailsError: boolean = false;
    private latestPartnerPractice: PartnerPractice = {
        ...this.partnerPractice,
        addresses: [...this.partnerPractice.addresses],
        originalSourceTypes: [...this.partnerPractice.originalSourceTypes],
        emailAttachments: [...this.partnerPractice.emailAttachments],
    };

    private isAddressVisible: boolean = false;
    private isAddressEdit: boolean = false;
    private selectedAddress: PartnerPracticeAddress | null = null;

    private isUserVisible: boolean = false;
    private isResendUserInviteConfirmationDialogVisible: boolean = false;
    private isUnassignUserConfirmationDialogVisible: boolean = false;
    private isRestoreUserConfirmationDialogVisible: boolean = false;
    private isArchiveUserConfirmationDialogVisible: boolean = false;
    private userCurrentTab: number = 0;
    private showUserDetailsError: boolean = false;
    private selectedUser: User | null = null;

    private isEmailVisible: boolean = false;
    private isEmailEdit: boolean = false;
    private importEmailAttachment: boolean = false;
    private emailAttachmentFile: File | null = null;
    private selectedEmailAttachment: PartnerPracticeEmailAttachment | null = null;

    private get showAddressesError(): boolean {
        return this.latestPartnerPractice.addresses.length < 1;
    }

    private get showUserRolesError(): boolean {
        return this.selectedUser == null ? false : this.selectedUser.roles.length < 1;
    }

    @Watch('visible')
    private onVisibleChanged(visible: boolean): void {
        this.isVisible = visible;
    }

    private async onSaveAsync(): Promise<void> {
        if (!(await (this.$refs.details as Vue).$validator.validateAll('partner-practice-details')) || this.latestPartnerPractice.addresses.length < 1) {
            return;
        }

        this.isSaving = true;

        try {
            await partnerPracticeApi.updatePartnerPracticeAsync({
                ...this.latestPartnerPractice,
                id: this.latestPartnerPractice.id!,
                addresses: [...this.latestPartnerPractice.addresses],
                emailAttachments: [...this.latestPartnerPractice.emailAttachments],
                originalSourceTypes: [...this.latestPartnerPractice.originalSourceTypes],
                isArchived: this.latestPartnerPractice.isArchived!,
                version: this.latestPartnerPractice.version!,
            });

            this.$emit('ok', { ...this.latestPartnerPractice });
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not update partner practice '${this.latestPartnerPractice.name}'. Please try again.`, type: 'is-danger' });
            }
        }

        this.isSaving = false;
    }

    private onCancel(): void {
        this.$emit('cancel');
    }

    private onDetailsErrorsChanged(hasErrors: boolean): void {
        this.showDetailsError = hasErrors;
    }

    private async onSaveAddressAsync(): Promise<void> {
        if (!(await (this.$refs.address as Vue).$validator.validateAll('address-details'))) {
            return;
        }

        this.isSaving = true;

        if (this.isAddressEdit) {
            const index = this.latestPartnerPractice.addresses.findIndex((address) => address.id === this.selectedAddress!.id!);

            if (index > -1) {
                if (this.selectedAddress!.id === 'editing') {
                    this.selectedAddress!.id = null;
                }

                this.latestPartnerPractice.addresses.splice(index, 1, { ...this.selectedAddress! });
            } else {
                this.$snackbar.open({ message: 'Could not update address. Please try again.', type: 'is-danger' });
            }
        } else {
            this.latestPartnerPractice.addresses.push({ ...this.selectedAddress! });
        }

        this.isSaving = false;
        this.onCancelAddress();
    }

    private onAddAddress(): void {
        this.selectedAddress = createPartnerPracticeAddress();
        this.isAddressVisible = true;
    }

    private onEditAddress(address: PartnerPracticeAddress): void {
        if (address.id == null) {
            address.id = 'editing';
        }

        this.selectedAddress = { ...address };
        this.isAddressEdit = true;
        this.isAddressVisible = true;
    }

    private onRemoveAddress(index: number): void {
        this.latestPartnerPractice.addresses.splice(index, 1);
        this.onCancelAddress();
    }

    private onCancelAddress(): void {
        for (const address of this.latestPartnerPractice.addresses.filter((a) => a.id === 'editing')) {
            address.id = null;
        }

        this.selectedAddress = null;
        this.isAddressEdit = false;
        this.isAddressVisible = false;
    }

    private async fetchUsersAsync(): Promise<void> {
        this.isLoading = true;

        await this.$store.dispatch(`users/loadAllUsersAsync`);
        this.latestPartnerPractice.users = this.partnerPracticeUsers(this.partnerPractice.id!);

        this.isLoading = false;
    }

    private async onSaveUserAsync(): Promise<void> {
        const isDetailsValid = await (this.$refs.userDetails as Vue).$validator.validateAll('user-details');
        const isRolesValid = this.selectedUser!.roles.length > 0;
        const isTargetsValid = this.selectedUser!.id == null ? true : await (this.$refs.userTargets as Vue).$validator.validateAll('user-targets');

        if (!isDetailsValid || !isRolesValid || !isTargetsValid) {
            return;
        }

        this.isSaving = true;

        try {
            if (this.selectedUser!.id == null) {
                await userApi.createUserAsync({ ...this.selectedUser!, roles: this.selectedUser!.roles.map((role) => role.name) });
                this.$snackbar.open({ message: `User '${this.selectedUser!.email}' has been created.`, type: 'is-success' });
            } else {
                await userApi.updateUserAsync({
                    ...this.selectedUser!,
                    id: this.selectedUser!.id!,
                    isArchived: this.selectedUser!.isArchived!,
                    roles: this.selectedUser!.roles.map((role) => role.name),
                    targets: [...this.selectedUser!.targets],
                    version: this.selectedUser!.version!,
                });

                this.$snackbar.open({ message: `User '${this.selectedUser!.email}' has been updated.`, type: 'is-success' });
            }

            this.onCancelUser();
            await this.fetchUsersAsync();
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not ${this.selectedUser!.id == null ? 'create' : 'update'} user '${this.selectedUser!.email}'.`, type: 'is-danger' });
            }
        }

        this.isSaving = false;
    }

    private async onResendUserInviteConfirmedAsync(): Promise<void> {
        try {
            await userApi.reinviteUserAsync({ ...this.selectedUser! });
            this.$snackbar.open({ message: `Activation e-mail sent to user '${this.selectedUser!.email}'.`, type: 'is-success' });
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not re-send activation e-mail to user '${this.selectedUser!.email}'.`, type: 'is-danger' });
            }
        }

        this.onCancelUser();
        await this.fetchUsersAsync();
    }

    private async onUnassignUserConfirmedAsync(): Promise<void> {
        try {
            await userApi.unassignFromPartnerPracticeAsync(this.selectedUser!.id!);
            this.$snackbar.open({ message: `User '${this.selectedUser!.email}' un-assigned from partner practice '${this.latestPartnerPractice.name}'.`, type: 'is-success' });
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not un-assign user '${this.selectedUser!.email}' from partner practice '${this.latestPartnerPractice.name}'.`, type: 'is-danger' });
            }
        }

        this.onCancelUser();
        await this.fetchUsersAsync();
    }

    private async onRestoreUserConfirmedAsync(): Promise<void> {
        try {
            await userApi.updateUserAsync({
                ...this.selectedUser!,
                id: this.selectedUser!.id!,
                isArchived: false,
                roles: this.selectedUser!.roles.map((role) => role.name),
                version: this.selectedUser!.version!,
            });

            this.$snackbar.open({ message: `User '${this.selectedUser!.email}' has been restored.`, type: 'is-success' });
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not restore user '${this.selectedUser!.email}'.`, type: 'is-danger' });
            }
        }

        this.onCancelUser();
        await this.fetchUsersAsync();
    }

    private async onArchiveUserConfirmedAsync(): Promise<void> {
        try {
            await userApi.deleteUserAsync({ ...this.selectedUser! });
            this.$snackbar.open({ message: `User '${this.selectedUser!.email}' has been archived.`, type: 'is-success' });
        } catch (e) {
            if (e instanceof Error) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            } else {
                this.$snackbar.open({ message: `Could not archive user '${this.selectedUser!.email}'.`, type: 'is-danger' });
            }
        }

        this.onCancelUser();
        await this.fetchUsersAsync();
    }

    private onAddUser(): void {
        this.selectedUser = createUser(this.partnerPractice.id!);
        this.userCurrentTab = 0;
        this.isUserVisible = true;
    }

    private onEditUser(user: User): void {
        this.selectedUser = { ...user, roles: [...user.roles] };
        this.userCurrentTab = 0;
        this.isUserVisible = true;
    }

    private onResendUserInvite(user: User): void {
        this.selectedUser = { ...user, roles: [...user.roles] };
        this.isResendUserInviteConfirmationDialogVisible = true;
    }

    private onUnassignUser(user: User): void {
        this.selectedUser = { ...user, roles: [...user.roles] };
        this.isUnassignUserConfirmationDialogVisible = true;
    }

    private onRestoreUser(user: User): void {
        this.selectedUser = { ...user, roles: [...user.roles] };
        this.isRestoreUserConfirmationDialogVisible = true;
    }

    private onArchiveUser(user: User): void {
        this.selectedUser = { ...user, roles: [...user.roles] };
        this.isArchiveUserConfirmationDialogVisible = true;
    }

    private onCancelUser(): void {
        this.isUserVisible = false;
        this.isResendUserInviteConfirmationDialogVisible = false;
        this.isUnassignUserConfirmationDialogVisible = false;
        this.isRestoreUserConfirmationDialogVisible = false;
        this.isArchiveUserConfirmationDialogVisible = false;

        this.selectedUser = null;

        setTimeout(() => { this.currentTab = 2; }, 0);
    }

    private onUserDetailsErrorsChanged(hasErrors: boolean): void {
        this.showUserDetailsError = hasErrors;
    }

    private async onSaveEmailAttachmentAsync(): Promise<void> {
        if (!(await (this.$refs.email as Vue).$validator.validateAll('email-attachment'))) {
            return;
        }

        this.isSaving = true;

        if (this.importEmailAttachment) {
            if (!(await this.uploadFileAsync())) {
                this.isSaving = false;
                return;
            }

            this.selectedEmailAttachment!.attachmentFilename = this.emailAttachmentFile!.name;
        }

        const extension = `.${this.selectedEmailAttachment!.attachmentFilename!.split('.').pop()}`;
        const formattedAlias = this.selectedEmailAttachment!.attachmentAlias != null && this.selectedEmailAttachment!.attachmentAlias.trim() !== ''
            ? `${this.selectedEmailAttachment!.attachmentAlias.trim()}${!this.selectedEmailAttachment!.attachmentAlias.trim().toLowerCase().endsWith(extension) ? extension : ''}`
            : null;

        if (this.isEmailEdit) {
            const index = this.latestPartnerPractice.emailAttachments.findIndex((email) => email.id === this.selectedEmailAttachment!.id!);

            if (index > -1) {
                if (this.selectedEmailAttachment!.id === 'editing') {
                    this.selectedEmailAttachment!.id = null;
                }

                this.latestPartnerPractice.emailAttachments.splice(index, 1, { ...this.selectedEmailAttachment!, attachmentAlias: formattedAlias });
            } else {
                this.$snackbar.open({ message: 'Could not update e-mail attachment. Please try again.', type: 'is-danger' });
            }
        } else {
            this.latestPartnerPractice.emailAttachments.push({ ...this.selectedEmailAttachment!, attachmentAlias: formattedAlias });
        }

        await this.$store.dispatch(`attachment/fetchEmailAttachmentsAsync`);

        this.isSaving = false;
        this.onCancelEmailAttachment();
    }

    private onAddEmailAttachment(): void {
        this.selectedEmailAttachment = createPartnerPracticeEmailAttachment();
        this.importEmailAttachment = false;
        this.emailAttachmentFile = null;
        this.isEmailVisible = true;
    }

    private onEditEmailAttachment(attachment: PartnerPracticeEmailAttachment): void {
        if (attachment.id == null) {
            attachment.id = 'editing';
        }

        this.selectedEmailAttachment = { ...attachment };
        this.importEmailAttachment = false;
        this.emailAttachmentFile = null;
        this.isEmailEdit = true;
        this.isEmailVisible = true;
    }

    private onRemoveEmailAttachment(index: number): void {
        this.latestPartnerPractice.emailAttachments.splice(index, 1);
        this.onCancelEmailAttachment();
    }

    private onCancelEmailAttachment(): void {
        for (const email of this.latestPartnerPractice.emailAttachments.filter((e) => e.id === 'editing')) {
            email.id = null;
        }

        this.selectedEmailAttachment = null;
        this.importEmailAttachment = false;
        this.emailAttachmentFile = null;
        this.isEmailEdit = false;
        this.isEmailVisible = false;
    }

    private onImportEmailAttachmentChanged(importFile: boolean): void {
        this.importEmailAttachment = importFile;
    }

    private onEmailAttachmentFileChanged(attachmentFile: File | null): void {
        this.emailAttachmentFile = attachmentFile;
    }

    private async uploadFileAsync(): Promise<boolean> {
        try {
            await emailAttachmentApi.emailAttachmentAsync(this.emailAttachmentFile!);
            this.$snackbar.open({ message: `Email attachment '${this.emailAttachmentFile!.name}' has been uploaded.`, type: 'is-success' });

            return true;
        } catch (e) {
            if (e instanceof BadRequest) {
                this.$snackbar.open({ message: e.message, type: 'is-danger' });
            }

            this.$snackbar.open({ message: `Could not upload '${this.emailAttachmentFile!.name}'. Please try again.`, type: 'is-danger' });

            return false;
        }
    }

    private async mounted(): Promise<void> {
        this.isLoading = true;

        await this.fetchUsersAsync();

        this.isLoading = false;
    }
}
